import { PaginationParams, Review } from "types/general.interface";
import {
  handleDeleteRequest,
  handleGetRequest,
  handlePostRequest,
  handlePutRequest,
} from "./http.service";
import { PaginationDataRes } from "types/http.type";
import { Booking, Job } from "types/booking.interface";
import { JobCreate } from "types/job.interface";
import { Blog, BlogCreate } from "types/blog.type";

export const getBlogs = async (paginationOptions: PaginationParams) => {
  return await handleGetRequest<PaginationDataRes<Blog[]>>(
    `/blogs?page=${paginationOptions.page}&limit=${paginationOptions.limit}`
  );
};

export const getBlogPost = async (slug: string) => {
  return await handleGetRequest<Blog>(`/blogs/${slug}`);
};

export const editBlog = async (id: string, payload: BlogCreate) => {
  return await handlePutRequest<BlogCreate, null>(`/blogs/${id}`, payload);
};
export const deleteBlog = async (id: string) => {
  return await handleDeleteRequest(`/blogs/${id}`);
};

export const createBlog = async (blog: BlogCreate) => {
  return await handlePostRequest<BlogCreate, Job>(`/blogs`, blog);
};
